import { Button, ButtonGroup } from "@chakra-ui/button";
import { Heading } from "@chakra-ui/layout";
import React, { useEffect, useState, useMemo } from "react";
import Layout from "../../components/Layout";
import ToggleRow from "../../components/ToggleRow";
import SKCard from "../../components/UI/SKCard";
import { SIKKA_FAQS, SECTION_NAMES } from "@/data/faq";
import classes from "./styles.module.scss";
import LinkIcon from "@/public/assets/icons/link.svg";
import { FAQS_PAGE } from "../../constants/route.const";
import { useToast } from "@chakra-ui/toast";
import { copyToClickBoard } from "../../utils";
import { PACKAGE } from "../../constants";
import { StorageService } from "../../service/Storage";
import { useRouter } from "next/router";
import FAQLanguageTitle from "@/components/FAQLanguageTitle";

const SUPPORTED_LANGS = ["en", "hi", "mr", "gu", "id"];

export default function Faq(props) {
  const toast = useToast();
  const router = useRouter();
  const params = router.query;

  const getLangFromQuery = () => {
    const queryLang = params.lang;
    // Map 'in' to 'id' for Indonesian
    const mappedLang = queryLang === 'in' ? 'id' : queryLang;
    // Validate against supported languages
    if (mappedLang && SUPPORTED_LANGS.includes(mappedLang)) {
      return mappedLang;
    }
    return 'en';
  };

  const [lang, setLang] = useState("en");

  useEffect(() => {
    const initialLang = getLangFromQuery();
    setLang(initialLang);
    StorageService.setXPN(PACKAGE);
  }, [params.lang]);

  // Group FAQs by section
  const groupedFAQs = useMemo(() => {
    const groups = {};
    SIKKA_FAQS.forEach(faq => {
      if (!groups[faq.sectionKey]) {
        groups[faq.sectionKey] = [];
      }
      groups[faq.sectionKey].push(faq);
    });
    return groups;
  }, []);

  return (
    <Layout>
      <div className={classes.FaqPage}>
        <FAQLanguageTitle lang={lang} />

        <div style={{ margin: "1rem 0rem" }}>
          <ButtonGroup variant="solid" spacing="0" size="xs" isAttached>
            <Button
              bg={lang === "en" ? "#028C6A" : "#E2E8F0"}
              color={lang === "en" ? "white" : "#1A202C"}
              _hover={{ bg: lang === "en" ? "#026B52" : "#CBD5E0" }}
              onClick={() => setLang("en")}
            >
              English
            </Button>
            <Button
              bg={lang === "hi" ? "#028C6A" : "#E2E8F0"}
              color={lang === "hi" ? "white" : "#1A202C"}
              _hover={{ bg: lang === "hi" ? "#026B52" : "#CBD5E0" }}
              onClick={() => setLang("hi")}
            >
              हिंदी
            </Button>
            <Button
              bg={lang === "mr" ? "#028C6A" : "#E2E8F0"}
              color={lang === "mr" ? "white" : "#1A202C"}
              _hover={{ bg: lang === "mr" ? "#026B52" : "#CBD5E0" }}
              onClick={() => setLang("mr")}
            >
              मराठी
            </Button>
            <Button
              bg={lang === "gu" ? "#028C6A" : "#E2E8F0"}
              color={lang === "gu" ? "white" : "#1A202C"}
              _hover={{ bg: lang === "gu" ? "#026B52" : "#CBD5E0" }}
              onClick={() => setLang("gu")}
            >
              ગુજરાતી
            </Button>
            <Button
              bg={lang === "id" ? "#028C6A" : "#E2E8F0"}
              color={lang === "id" ? "white" : "#1A202C"}
              _hover={{ bg: lang === "id" ? "#026B52" : "#CBD5E0" }}
              onClick={() => setLang("id")}
            >
              Indonesia
            </Button>
          </ButtonGroup>
        </div>

        <div className={classes.FaqList}>
          {Object.keys(groupedFAQs).map(sectionKey => (
            <div key={sectionKey}>
              <h2 className={classes.sectionTitle}>
                {SECTION_NAMES[sectionKey][lang]}
              </h2>
              {groupedFAQs[sectionKey].map(
                d =>
                  d[lang] && (
                    <SKCard className={classes.card} id={`${d.key}`} key={d.key}>
                      <ToggleRow
                        key={d.key}
                        header={
                          <div className={classes.rowHeader}>
                            <LinkIcon
                              className={classes.linkIcon}
                              onClick={() => {
                                const FAQ_LINK = `${window.location.origin}${FAQS_PAGE}?lang=${lang}#${d.key}`;

                                router.replace(`${FAQS_PAGE}#${d.key}`);

                                if (copyToClickBoard(FAQ_LINK)) {
                                  toast({ title: "Link copied!", key: "faq-link" });
                                }
                              }}
                            />
                            {d[lang].title}
                          </div>
                        }
                        body={d[lang].desc}
                        defaultOpen={
                          `#${d.key}` === `#${router.asPath.split("#")[1]}`
                        }
                      />
                    </SKCard>
                  )
              )}
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
